import {CampService} from './CampService';

export class CampAction extends CampService {

    pkAction: number;
    typeAction: string;
    actionName: string;
    actionFilename: string;

    constructor(campData: Object){
        super(campData);

        this.pkAction = campData['pk_action'];
        this.typeAction = campData['type_action'];
        this.actionFilename = campData['action_filename'];
        this.actionName = campData['action_name'];
    }

    getPkAction(): number {
        return this.pkAction;
    }

    getTypeAction(): string {
        return this.typeAction;
    }


    getActionName(): string {
        return this.actionName;
    }

    getActionFilename(): string {
        return this.actionFilename;
    }
}


// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/model/CampAction.ts